import { apiRequest } from "./client";

export function loginFowebPortalUser({ name, password }) {
  return apiRequest("/fowebportalusers/login", {
    method: "POST",
    body: { name, password, host: window.location.hostname },
  });
}

export function getFowebPortalUser(id) {
  const host = encodeURIComponent(window.location.hostname);
  return apiRequest(`/fowebportalusers/${id}?host=${host}`);
}
